import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/bus.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-22ce9abc")

_pushScopeId("data-v-22ce9abc")
const _hoisted_1 = { id: "entire_app__transport_means" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title_container" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "pulse-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_31",
      "data-name": "Path 31",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_32",
      "data-name": "Path 32",
      d: "M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z",
      fill: "#1d2329"
    })
  ]),
  /*#__PURE__*/_createVNode("h2", null, "Transport categories")
], -1)
const _hoisted_3 = { class: "transport_means_container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "image_container" }, [
  /*#__PURE__*/_createVNode("div", { class: "img_box" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_5 = { class: "time_weather_container" }
const _hoisted_6 = { class: "time_weather" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("p", null, "Current time")
], -1)
const _hoisted_9 = { class: "time_clock" }
const _hoisted_10 = { class: "weather" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("p", null, "Weather")
], -1)
const _hoisted_12 = { class: "weather_clock" }
const _hoisted_13 = /*#__PURE__*/_createVNode("sup", null, "o", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("c")
const _hoisted_15 = { class: "entire_transport_means__body_content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("h1", null, _toDisplayString(_ctx.time) + " " + _toDisplayString(_ctx.timePeriod), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("h1", null, [
                _createTextVNode(_toDisplayString(_ctx.temperature) + " ", 1),
                _hoisted_13,
                _hoisted_14
              ]),
              _createVNode("p", null, _toDisplayString(_ctx.weatherStatus), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_router_view)
    ])
  ]))
})